import { lazy } from 'react';

export const ConfirmLanguage = lazy(() => import('./ConfirmLanguage'));
export const SuccessLanguageChange = lazy(() => import('./SuccessLanguageChange'));
export const ChangeLanguageStore = lazy(() => import('./ChangeLanguageStore'));
export const ChangeLanguageCheckout = lazy(() => import('./ChangeLanguageCheckout'));
